import React from "react";

import { noop } from "lodash";

import { dispatchAnalyticsTrack, getReferringEntities } from "~/lib/segment";

export function dispatchDesktopAnalyticsTrack({
	feature,
	event,
	properties,
}: {
	feature: string;
	event: string;
	properties?: Record<string, string>;
}) {
	const analyticsData = { ...getReferringEntities(), ...properties, feature };

	dispatchAnalyticsTrack(event, analyticsData);
}

export function Analytics() {
	React.useEffect(() => {
		if (window.desktopAnalyticsV1?.registerAnalyticsEventListener) {
			window.desktopAnalyticsV1?.registerAnalyticsEventListener(dispatchDesktopAnalyticsTrack);
		}

		return () => window.desktopAnalyticsV1?.registerAnalyticsEventListener?.(noop);
	}, []);

	return <></>;
}

export default Analytics;
